// users/search — the fields a person is searched by, ONE function both faces
// call (ADR-072 §6 · ADR-045: the file matches what the screen matched): the
// name by its words (a mistake forgiven), the username a KEY (typed whole it
// answers alone; typed in part a code), the e-mail a code — the users pages'
// `useListController` and the users export's `matchRows`. The server's own
// people search holds the same split in its columns (`search_name` ·
// `search_handle` · `search_email`).
export function userSearchFields(u) {
    return { name: `${u.first_name} ${u.last_name}`, keys: [u.username], codes: [u.email] };
}
